export const MODES = {
	APP: 'app',
	NOTIFICATIONS: 'notifications',
	MANAGEMENT: 'management',
	SCHEDULE: 'schedule'
}
